module.exports = require('./script');

module.exports.Interpreter = require('./interpreter');



//////////////////
// WEBPACK FOOTER
// ./~/bitcore-lib/lib/script/index.js
// module id = 72
// module chunks = 0